import type { ISeatStatus } from "../../FacilityManager/Domain/Types/FloorPlan/SeatStatus.type";
import type { FloorAvailability } from "../../../features/FloorManager/typings/floor-inventory.entity";
import { filterListByCategory, tempFilterListByCategory } from "./form.functions";
import { getFloorInventoryIdsForSelection } from "./getFloorInventoryIdsForSelection.function";

/**
 * Builds floor-plan seat status for the workplace step.
 * Non-admins highlight only slot-available desks; inactive inventories stay in disableList.
 * Admins with inactive bypass use the full selectable pool so filter matches on inactive
 * inventories highlight like active ones (equipment, categories, properties — all types).
 */
export function buildWorkplaceSeatStatus(
  currentFloor: FloorAvailability,
  filteredSelectables: number[] | undefined,
  canBookInactive: boolean
): ISeatStatus {
  const filterBaseIds = getFloorInventoryIdsForSelection(currentFloor, canBookInactive);

  return {
    availableList: filterListByCategory(filterBaseIds, filteredSelectables),
    tempList: tempFilterListByCategory(filterBaseIds, filteredSelectables),
    occupiedList: currentFloor.occupiedInventoryIds,
    disableList: canBookInactive ? [] : currentFloor.disabledInventoryIds,
    restrictedList: currentFloor.forbiddenInventoryIds
  };
}
